import throttle from 'lodash.throttle';

declare global {
    interface Window {
        updateScrollSection: Function;
    }
}

export default class ScrollingNavBar {
    stickyNavLinkWrapper: HTMLElement;
    containerPadding: number;
    staticNavPos: number;
    sections: {};
    activeSectionArr: string[];
    stickyNav: HTMLElement;
    stickyNavHeight: number;

    init() {
        this.stickyNav = document.querySelector('.sticky-nav');

        if (this.stickyNav !== null) {
            const navLinks = document.querySelectorAll('.nav a');
            this.stickyNavLinkWrapper = this.stickyNav.querySelector('.has-horizontal-scroll');
            this.stickyNavHeight = this.stickyNav.getBoundingClientRect().height;
            const staticNav = document.querySelector('.static-nav');
            this.staticNavPos = staticNav.getBoundingClientRect().bottom + window.pageYOffset;
            this.containerPadding = parseFloat(window.getComputedStyle(this.stickyNavLinkWrapper).getPropertyValue('padding-left'));
            this.sections = {};
            this.activeSectionArr = [];

            // get section positions
            const updateSectionPositions = () => {
                const allSections = document.querySelectorAll('.scroll-section');

                Array.prototype.forEach.call(allSections, (section) => {
                    let pos = section.getBoundingClientRect().top + window.pageYOffset - this.stickyNavHeight;
                    this.sections[section.id] = Math.round(pos);
                });
            }

            window.updateScrollSection = updateSectionPositions;

            updateSectionPositions();

            window.addEventListener('scroll', throttle(this.handleScroll.bind(this), 100));

            // scroll to section
            Array.prototype.forEach.call(navLinks, (link) => {
                link.addEventListener('click', (event) => {
                    event.preventDefault();
                    window.scrollTo({ top: this.getTargetPosition(link), behavior: 'smooth' });
                });
            });

            this.dragNav();
        }
    }

    handleScroll() {
        const scrollPosition = window.pageYOffset;
        this.activeSectionArr = [];

        for (let section in this.sections) {
            if (this.sections[section] <= scrollPosition) {
                this.activeSectionArr.push(section);
            }
        }

        // scroll spy
        if (this.activeSectionArr.length > 0) {
            const activeSection = this.stickyNav.querySelector(`a[href='#${this.activeSectionArr[this.activeSectionArr.length - 1]}']`) as HTMLAnchorElement;
            const hasActiveClass = this.stickyNav.querySelector('.is-active');

            if (hasActiveClass !== activeSection) hasActiveClass.classList.remove('is-active');

            if (!activeSection.classList.contains('is-active')) {
                activeSection.classList.add('is-active');

                // scroll nav horizontally
                let newScrollPosition = activeSection.offsetLeft - this.stickyNavLinkWrapper.scrollLeft - this.containerPadding;
                this.stickyNavLinkWrapper.scrollBy({ top: 0, left: newScrollPosition, behavior: 'smooth' });
            }
        }

        // toggle sticky nav
        if (this.staticNavPos - this.stickyNavHeight <= scrollPosition) {
            if (!this.stickyNav.classList.contains('is-active')) this.stickyNav.classList.add('is-active');
        } else {
            if (this.stickyNav.classList.contains('is-active')) this.stickyNav.classList.remove('is-active');
        }
    }

    getTargetPosition(link) {
        const targetId = link.getAttribute('href');
        const targetEl = document.querySelector(targetId);
        const targetPos = targetEl.getBoundingClientRect().top;
        const navBarHeight = this.stickyNav.getBoundingClientRect().height;
        const titleBar = targetEl.querySelector('.title-bar');
        let position = targetPos + window.pageYOffset - navBarHeight;

        if (titleBar !== null ) {
            const titleBarHeight = titleBar.getBoundingClientRect().height;
            position += titleBarHeight;
        }
        return Math.round(position);
    }

    dragNav() {
        // horizontally drag nav
        let pos = { left: 0, x: 0 };
        let mouseIsDown = false;

        const mouseDownHandler = e => {
            mouseIsDown = true;

            pos = {
                // The current scroll
                left: this.stickyNavLinkWrapper.scrollLeft,

                // Get the current mouse position
                x: e.clientX,
            };
        };

        const mouseMoveHandler = e => {
            if (mouseIsDown) {
                this.stickyNavLinkWrapper.classList.add('is-dragging');

                // How far the mouse has been moved
                const dx = e.clientX - pos.x;

                // Scroll the element
                this.stickyNavLinkWrapper.scrollLeft = pos.left - dx;
            }
        };

        const mouseUpHandler = () => {
            mouseIsDown = false;
            this.stickyNavLinkWrapper.classList.remove('is-dragging');
        };

        this.stickyNavLinkWrapper.addEventListener('mousedown', mouseDownHandler);
        document.addEventListener('mousemove', mouseMoveHandler);
        document.addEventListener('mouseup', mouseUpHandler);
        document.addEventListener('dragstart', e => {
            if (mouseIsDown) e.preventDefault();
        });
    }
}

